@let isEditing = userStateService.navbarButtonState() === 'EDIT';
@let work = artwork.value()?.data;

@if(work){
  <div class="p-4 w-full h-full overflow-auto flex flex-col gap-2" *transloco="let t">
    <div class="flex gap-2 text-2xl items-center">
      <div class="font-bold">
        {{t('artworks.title')}}:
      </div>
      <div class="font-thin">
        <input wunInput [readonly]="!isEditing" [formControl]="form.controls.name">
      </div>
    </div>
    <div class="flex">
      <wun-media-render inputClass="!w-60" [media]="work.mainAttachment!" />
      @if (thumbs().length > 1) {
        <div class="grid grid-cols-2 gap-2">
          @for (media of thumbs(); track media.id) {
            <wun-media-render inputClass="!w-20" [media]="media" />
          }
        </div>
      }
    </div>
    <div [formGroup]="form" class="flex flex-col gap-2">
      <div class="flex gap-3" >
        <div wunInputContainer>
          <label>Tipo</label>
          <wun-dropdown overrideClass="!left-0" #type>
            <button trigger class="border border-wundart-gray-200 h-12 p-1 w-24" [class.border-0]="!isEditing" [disabled]="!isEditing" (click)="type.toggle()">
              {{form.value.type}}
            </button>
            <ng-template wunDropdownItem>
              <div class="flex gap-2 items-center w-full" (click)="form.controls.type.setValue('PHYSICAL')">
                PHYSICAL
              </div>
            </ng-template>
            <ng-template wunDropdownItem>
              <div class="flex gap-2 items-center w-full" (click)="form.controls.type.setValue('DIGITAL')">
                DIGITAL
              </div>
            </ng-template>
          </wun-dropdown>
        </div>
        <div wunInputContainer>
          <label>Altezza</label>
          <input [readonly]="!isEditing" formControlName="height" wunInput type="number">
        </div>
        <div wunInputContainer>
          <label>Larghezza</label>
          <input  [readonly]="!isEditing" formControlName="width" wunInput type="number">
        </div>
        <div wunInputContainer>
          <label>Profonditá</label>
          <input  [readonly]="!isEditing" formControlName="depth" wunInput type="number">
        </div>
        <div wunInputContainer>
          <label>Peso</label>
          <input  [readonly]="!isEditing" formControlName="weight" wunInput type="number">
        </div>
        <div wunInputContainer>
          <label>Unica</label>
          <wun-dropdown overrideClass="!left-0" #isUnique>
            <button trigger  [class.border-0]="!isEditing" class="border border-wundart-gray-200 p-1 w-24" [disabled]="!isEditing" (click)="isUnique.toggle()">
              {{form.value.isUnique ? 'SI' : 'NO'}}
            </button>
            <ng-template wunDropdownItem>
              <div class="flex gap-2 items-center w-full" (click)="form.controls.isUnique.setValue(true)">
                SI
              </div>
            </ng-template>
            <ng-template wunDropdownItem>
              <div class="flex gap-2 items-center w-full" (click)="form.controls.isUnique.setValue(false)">
                NO
              </div>
            </ng-template>
          </wun-dropdown>
        </div>


        <div wunInputContainer>
          <label>Unitá</label>
          <input [readonly]="!isEditing" formControlName="unit" wunInput type="number">
        </div>

      </div>
      <div class="w-full" wunInputContainer>
        <label>Descrizione</label>
        <textarea [readonly]="!isEditing" wunInput [rows]="4" style="height: 128px" formControlName="description"></textarea>
      </div>
    </div>
    @if (artwork.value()?.data?.price && !artwork.value()?.data?.evaluation) {
      l'artista ha dato valutato l'opera {{artwork.value()?.data?.price}}. Puoi inserire una valutazione diversa per questa opera
    }
    <div class="flex gap-2 pb-10" [formGroup]="evaluationForm">
      <div class="flex items-center gap-3">
        <label class="whitespace-nowrap">Work estimate</label>
        <input wunInput class="!w-20" formControlName="estimate" type="number">
      </div>
      <div class="flex items-center gap-3">
        <label class="whitespace-nowrap">Packaging cost</label>
        <input wunInput class="!w-20" formControlName="shippingCosts" type="number">
      </div>
      <div wunInputContainer class="font-thin">
        <wun-dropdown overrideClass="!left-0" #state>
          <button trigger class="border border-wundart-gray-200 p-1 h-12"  (click)="state.toggle()">
            {{t('ARTWORK_ENUM.' + form.controls.status.value)}}
          </button>
          <ng-template wunDropdownItem>
            <div class="flex gap-2 items-center w-full" (click)="form.controls.status.setValue('APPROVED')">
              Approve

            </div>
          </ng-template>
          <ng-template wunDropdownItem>
            <div class="flex gap-2 items-center w-full" (click)="form.controls.status.setValue('DECLINED')">
              Decline
            </div>
          </ng-template>
        </wun-dropdown>
      </div>
      <div>
        <wun-file-uploader (currentMediaChange)="fileSelected($event)" [isImg]="false" accept=".pdf" #file>
          <ng-template #triggerElement>
            <button wunButton class="!h-12" (click)="file.trigger()" primary>Upload report</button>
          </ng-template>
        </wun-file-uploader>
      </div>
      <div>
        <button wunButton green class="!h-12" (click)="saveEvaluation()">
          Save evaluation
        </button>
      </div>
    </div>

  </div>
}
